import { SiteInfo } from '../../transport.interface';

export class SaveSiteInfoAction {
  static readonly type = '[Site] Save';

  constructor(public payload: SiteInfo) {
  }
}
